import { gql } from "@apollo/client";

const GET_BOOKABLE_CLASSES = gql`
  query GetBookableClasses(
    $topicId: ID
    $chapterId: ID
    $first: Int
    $after: String
    $cities: [String!]!
  ) {
    bookableClasses(
      topicId: $topicId
      chapterId: $chapterId
      cities: $cities
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      nodes {
        id
        date
        time
        startTime
        classType
        seatsRemaining
        bookedAt
        overlapped
        classSize
        category
        credits
        language {
          id
          englishName
          realName
          bannerBackground
        }
        teacher {
          id
          avatar
          givenName
          familyName
        }
        topic {
          id
          title
        }
        chapter {
          name
        }
        level {
          title
        }
        city {
          id
          name
        }
      }
    }
  }
`;

export default GET_BOOKABLE_CLASSES;
